import { useTranslation } from 'react-i18next'
import type { Lead } from '@/domains/types'

/**
 * A plain, non-sticky list of anchor links to each lead section, set as a
 * newspaper "sommaire": small tracked sans label, serif entries, marked off
 * with a rule rather than a card. Only worth
 * showing once there's enough content to actually navigate — below 3 leads
 * the reader just scrolls. Hidden entirely when printed: a table of contents
 * with `#anchor` links is meaningless on paper.
 */
export function ReadTableOfContents({ leads }: { leads: Lead[] }) {
  const { t } = useTranslation()

  if (leads.length < 3) return null

  return (
    <nav
      aria-label={t('read_mode.toc_title')}
      className="mb-12 border-l-2 border-border pl-5 print:hidden"
    >
      <p className="font-sans text-xl font-semibold uppercase tracking-[0.18em] text-muted-foreground mb-3">
        {t('read_mode.toc_title')}
      </p>
      <ol className="list-decimal pl-5 space-y-1.5">
        {leads.map((lead) => (
          <li key={lead.id} className="font-serif text-xl">
            <a href={`#read-lead-${lead.id}`} className="text-primary hover:underline">
              {lead.title}
            </a>
          </li>
        ))}
      </ol>
    </nav>
  )
}
